import React from "react";
import { Group } from "ol/layer.js";
import Map from "ol/Map.js";
import View from "ol/View.js";
import geoHelper from "../helpers/geo-helper";
import { Tile as TileLayer } from "ol/layer.js";
import OSM from "ol/source/OSM.js";
import LayerSwitcher from "ol-layerswitcher/src/ol-layerswitcher";
import { ZoomToExtent } from "ol/control.js";
import { Messages } from "../helpers/message-helper";
import { ZoomSlider } from "ol/control.js";
import BingMaps from "ol/source/BingMaps.js";
import { Event } from "../helpers/event-helper";
import { DomHelper } from "../helpers/dom-helper";
import layers from "../data/layers.json";
import baseLayers from "../data/base-layers.json";
import OverlayPopup from "./map/OverlayPopup";
import { toLonLat, transform } from "ol/proj.js";
import Fa from "./common/Fa";
import Alert from "./common/Alert";
import InfoCuenta from "./visor/InfoCuenta";
import Geolocation from "ol/Geolocation.js";

/**
 * Se importa jquery
 */
import jQuery from "jquery";
import InfoLegal from "./visor/InfoLegal";
global.jQuery = jQuery;
global.jquery = jQuery;
global.$ = jQuery;

/**
 * Visor con mapa y layers base.
 */
export default class Mapa extends React.Component {
  state = {
    info: false
  };

  map = null;
  featureReady = true;
  layers = [];
  lyParcWFS = null;
  queryLayer = null;
  clickHanlder = null;
  marker = null;
  geolocation = null;
  overlay = React.createRef();

  /**
   * Se encarga de inicializar el mapa.
   */
  componentDidMount() {
    this.props.onRef(this);
    this.initLayers();
    this.initMap();
    //se inicializa los controles
    this.initControls();
    this.bindInfo();
    this.bindEvents();
  }
  /**
   * Se encarga de mapear los metodos al evento correspondinete.
   */
  bindEvents() {
    Event.subscribe(Event.VISOR_BUSQUEDA, data => {
      this.search(data);
      this.infoCuenta(data);
    });

    Event.subscribe(Event.VISOR_LONLAT, data => {
      this.addMarker(data);
    });

    Event.subscribe(Event.VISOR_CURRENT_LOCATION, data => {
      this.currentLocation(data);
    });

    Event.subscribe(Event.VISOR_FEATURE_INFO, () =>
      this.setClickEvent("getFeatureInfo")
    );

    Event.subscribe(Event.VISOR_CLICK_INFO, () =>
      this.setClickEvent("getCoordinate")
    );
  }
  /**
   * Se encarga de añadir el atributo action en el mapa para customizar el icono del
   * cursor para el mouse over.
   *
   * @param {*} event
   */
  setClickEvent(event) {
    this.clickHanlder = event;
    jQuery("#map").attr("action", event);
  }

  /**
   * Se encarga de inicializar el mapa.
   */
  initMap() {
    this.map = new Map({
      layers: this.layers,
      target: "map",
      overlays: [this.overlay.get(), this.infoOverlay.get()],
      pixelRatio: 1, //Important, otherwise tiles with strange size will be requested
      view: new View({
        projection: geoHelper.projection,
        center: geoHelper.center,
        //extent: geoHelper.extent,
        maxZoom: 19,
        minZoom: 6,
        zoom: 6
      })
    });
    console.log(this.map.getView().calculateExtent());
  }

  /**
   * Se encarga de activar el control de getFeature info.
   */
  getFeatureInfo(evt) {
    let level = this.map.getView().getZoom();
    if (level < 16) {
      this.alert.open({
        title: Messages.get("Visor.getFeatureInfo.info.title"),
        message: Messages.get("Visor.getFeatureInfo.info.msg")
      });
      Event.publish(Event.MAP_FEATURE_ERROR);
      return;
    }
    this.queryLayer.setVisible(true);
    try {
      this.featureInfo(evt);
    } catch (error) {
      this.getFeatureInfoError(error);
    }
  }

  /**
   * Se encarga de abrir el popup con la inforamción de las coordenadas
   * UTM donde se hizo click.
   *
   * @param {*} evt
   */
  getCoordinate(evt) {
    
    var gmapsLonLat = transform(
      evt.coordinate,
      geoHelper.projection,
      "EPSG:4326"
    );
  
    function format(n) {
      var p = 1000000;
      return parseInt(n * p) / p;
    }

    this.overlay.close();
    this.overlay.open(
      evt.coordinate,
      <div>
        <h3>Ubicación</h3>
        <p>
          <Fa icon="map-marker-alt" />
          <code>
            {format(gmapsLonLat[0])},&nbsp;{format(gmapsLonLat[1])}
          </code>
        </p>

        {evt.detail}

        <small className="help">
          <Fa icon="info-circle" />
          Las coordenadas despelgadas anteriormente se encuentran en el sistema
          de proyecciones EPSG:4326.
        </small>
      </div>
    );
  }
  /**
   * Se encarga de habilitar el location que desplega la información de la ubicación
   * actual.
   *
   * @param {*} data
   */
  currentLocation(data) {
    this.geolocation.setTracking(true);
  }

  /**
   * Se encarga de añadir un marcador en el mapa.
   * @param {*} data
   */
  addMarker(data) {
    //se elimina el layer previo.
    if (this.marker !== null) {
      this.map.removeLayer(this.marker);
      this.map.updateSize();
    }

    var gmapsLonLat = transform(
      [data.lon, data.lat],
      "EPSG:4326",
      geoHelper.projection
    );

    this.marker = geoHelper.marker(gmapsLonLat);

    this.map.addLayer(this.marker);
    this.getCoordinate({ coordinate: gmapsLonLat, detail: data.detail });
    var extent = this.marker.getSource().getExtent();
    //se hace que el zoom a la ubicación dure 500 ms
    this.map.getView().fit(extent, { duration: 500, maxZoom: 14 });
  }

  /**
   * Se encarga de manejar el evento click del mapa. el handler del evento
   * depende del que control fue seteado previamente.
   */
  onClick(evt) {
    if (this[this.clickHanlder]) {
      this[this.clickHanlder](evt);
      this.clickHanlder = null;
      jQuery("#map").removeAttr("action");
    }
  }

  /**
   * Se encarga de inicializar el popup con datos del padron.
   */
  infoCuenta(data) {
    let d = {};
    d["dpto"] = data.dpto;
    d["dist"] = data.dist;
    d["zona"] = data.zona;
    d["manzana"] = data.manzana;
    d["lote"] = data.lote;
    d["padron"] = data.padron;
    this.infoOverlay.data(d);
  }

  /**
   * Se encarag ade inicalizar el overly con la información referente a la parcela.
   * @param {*} coordinate
   */
  openInfoCuenta(coordinate) {
    this.infoOverlay.open(coordinate);
  }

  /**
   *  Este método encarga de recupera la información del geoserver utilizando
   * la operación GetFeatureInfo para recuperar información de la parcela a fin de
   * recuperar los datos con WFS.
   *
   * @param {*} evt
   */
  featureInfo(evt) {
    let wms = this.queryLayer;
    if (!wms.getVisible()) {
      return;
    }
    this.infoOverlay.close();
    this.openInfoCuenta(evt.coordinate);
    geoHelper
      .getFeatureInfo(this.map, wms, evt.coordinate)
      .then(response => {
        let data = response.data;
        if (data.features !== null && data.features.length > 0) {
          data = data.features[0].properties;
          data.urbano = data.padron === 0 || data.padron === null;
          data.manzana = data.mz;
          Event.publish(Event.VISOR_BUSQUEDA, data);
        } else {
          this.getFeatureInfoError(data);
        }
      })
      .catch(error => {
        this.getFeatureInfoError(error);
      });
  }
  /**
   * Se encarga de despegar un mensaje de error notificando que no se pudo recuperar
   * la información mediante getFeatureInfo.
   * @param {*} error
   */
  getFeatureInfoError(error) {
    Event.publish(Event.MAP_FEATURE_ERROR);
    this.alert.open({
      title: Messages.get("Visor.getFeatureInfo.error.title"),
      message: Messages.get("Visor.getFeatureInfo.error.msg")
    });
    console.error(error);
  }

  /**
   * Se encarga de hacer bind de los eventos
   */
  bindInfo() {
    this.map.on("singleclick", evt => {
      this.onClick(evt);
    });
  }

  /**
   * Se encarga de inicializar el control de geolocalización que recupera
   * la info de la ubicación actual.
   */
  initGeolocation() {
    this.geolocation = new Geolocation({
      // enableHighAccuracy must be set to true to have the heading value.
      trackingOptions: {
        enableHighAccuracy: true
      },
      projection: "EPSG:4326"
    });

    this.geolocation.on("change:position", evt => {
      var coordinates = this.geolocation.getPosition();
      this.addMarker({
        lon: coordinates[0],
        lat: coordinates[1],
        detail: (
          <React.Fragment>
            <p className="help">
              <Fa icon="crosshairs"> </Fa> Exactitud de la ubicación estimada es
              de <code>{this.geolocation.getAccuracy()} </code> metros. Esto
              representa el radio de un círculo alrededor de la ubicación dada.
            </p>
          </React.Fragment>
        )
      });
      this.geolocation.setTracking(false);
    });
  }
  /**
   * Se encarga de inicializar los layers del visor
   */
  initLayers() {
    this.base();
    let groupLayer = [];
    layers.map(l => {
      let wms = geoHelper.wms(l);
      groupLayer.push(wms);
      if (l.principal) {
        this.queryLayer = wms;
      }
    });

    this.layers.push(
      new Group({
        title: "Capas del SNC",
        layers: groupLayer
      })
    );
  }

  /**
   *Se encarga de inicializar los controles del mapa.
   */
  initControls() {
    var layerSwitcher = new LayerSwitcher({
      tipLabel: "Leyenda",
      showPanel: true
    });

    var zoom = new ZoomToExtent({
      extent: geoHelper.extent
    });

    var zoomslider = new ZoomSlider();

    this.map.addControl(layerSwitcher);
    this.map.addControl(zoom);
    this.map.addControl(zoomslider);
    layerSwitcher.showPanel();
    this.initGeolocation();
  }

  /**
   * Se encaga de generar el layer base
   */
  base() {
    let group = [];
    baseLayers.map(l => {
      let source;
      if (l.type === "OSM") {
        source = new OSM();
      } else if (l.type === "BingMaps") {
        l.preload = Infinity;
        source = new BingMaps(l.source);
      }
      let current = Object.assign({}, l);
      current.type = "base";
      current.source = source;
      group.push(new TileLayer(current));
    });

    this.layers.push(
      new Group({
        title: "Capas bases",
        layers: group
      })
    );
  }

  /**
   * Se encarga de recuperar la geometría de la parcela (cuenta corriente
   * o padron) que cumple con los criterios de filtrado establecidos en formato
   * cql, la consulta se realiza utilizando WFS.
   */
  getParcela(filter) {
    //se elimina el layer previo.
    if (this.lyParcWFS !== null) {
      this.map.removeLayer(this.lyParcWFS);
    }

    this.lyParcWFS = geoHelper.wfs({
      layer: "parcelas_activas",
      title: "Resultado de la Búsqueda",
      workspace: "snc",
      visible: true,
      filter: filter
    });

    this.featureReady = true;

    let promise = new Promise((resolve, reject) => {
      this.lyParcWFS.getSource().once("change", event => {
        if (this.lyParcWFS.getSource().getState() !== "ready") {
          return;
        }

        try {
          if (this.featureReady) {
            this.featureReady = false;
            var extent = this.lyParcWFS.getSource().getExtent();
            //se hace que el zoom a la ubicación dure 500 ms
            this.map.getView().fit(extent, { duration: 500 });
            //se añade untimeout para que se center primero el mapa para
            //despues recuperar correctamente el centro. Se usa 600 ms para
            //darle tiempo a que se procese todo el zoom
            setTimeout(() => {
              //se abre el popup en el centro de la geometria
              let center = this.map.getView().getCenter();
              this.openInfoCuenta(center);
              //se resuelve el promise de forma exitosa
              resolve(this.lyParcWFS);
            }, 600);
          }
        } catch (error) {
          reject(error);
        }
      });
    });

    this.map.addLayer(this.lyParcWFS);

    //tmp.push();
    return promise;
  }
  /**
   * Se encarga de generar el filtro cql utilizado para recuperar la
   * parcela.
   */
  search(data) {
    this.map.updateSize();
    let cql = `dist=${data.dist} AND dpto='${data.dpto}'`;
    if (data.urbano) {
      data.manzana = data.manzana ? data.manzana : data.mz;
      cql += ` AND zona='${data.zona}' AND mz='${data.manzana}' AND lote='${data.lote}'`;
    } else {
      cql += ` AND padron='${data.padron}'`;
    }

    return this.getParcela(cql)
      .then(d => {
        Event.publish(Event.MAP_FEATURE_READY, data);
      })
      .catch(error => {
        this.alert.open({
          title: Messages.get("Visor.onSearch.error.title"),
          message: Messages.get("Visor.onSearch.error.msg")
        });
        Event.publish(Event.MAP_FEATURE_ERROR);
      });
  }
  /**
   * Se encarga de añadir un capa vectorial.
   * @param {*} params
   */
  addWFSLayer(params) {
    let wfs = geoHelper.wfs(params);
    this.map.addLayer(wfs);
    wfs.getSource().once("change", event => {
      if (wfs.getSource().getState() !== "ready") {
        return;
      }
      var extent = wfs.getSource().getExtent();
      //se hace que el zoom a la ubicación dure 500 ms
      this.map.getView().fit(extent, { duration: 500 });
    });
  }
  /**
   * Se encarga de renderizar el componente
   */
  render() {
    // 52 corresponde a la altura del nabvar principal.
    const minHeight = DomHelper.getHeight() - 52;
    return (
      <React.Fragment>
        <Alert onRef={ref => (this.alert = ref)} />
        <div id="map" style={{ height: `${minHeight}px` }} />
        <InfoLegal />
        <OverlayPopup onRef={ref => (this.overlay = ref)} />
        <InfoCuenta onRef={ref => (this.infoOverlay = ref)} />
      </React.Fragment>
    );
  }
}
